import { IonSpinner } from "@ionic/react";
import React from "react";
import styled from "styled-components";

const Center = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    height:100%;
    width:100%;
`;

const SplashScreen = () => {
	return <Center>
        <IonSpinner name="dots" ></IonSpinner>
    </Center>
};

export default SplashScreen;
